var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreshersOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8503 9.10168C17.9995 9.03587 18.1261 8.92774 18.2144 8.79068C18.3028 8.65363 18.3489 8.49367 18.3473 8.33063C18.3456 8.16758 18.2961 8.00862 18.2049 7.87342C18.1138 7.73822 17.985 7.63273 17.8345 7.57001L10.692 4.31668C10.4749 4.21764 10.239 4.16638 10.0003 4.16638C9.76166 4.16638 9.52579 4.21764 9.30865 4.31668L2.16699 7.56668C2.01863 7.63166 1.89242 7.73846 1.80379 7.87403C1.71517 8.00959 1.66797 8.16805 1.66797 8.33001C1.66797 8.49198 1.71517 8.65043 1.80379 8.786C1.89242 8.92157 2.01863 9.02837 2.16699 9.09335L9.30865 12.35C9.52579 12.4491 9.76166 12.5003 10.0003 12.5003C10.239 12.5003 10.4749 12.4491 10.692 12.35L17.8503 9.10168Z",
    stroke: "#726C6C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3359 8.33337V13.3334",
    stroke: "#726C6C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.4166V13.3333C5 13.9963 5.52678 14.6322 6.46447 15.1011C7.40215 15.5699 8.67392 15.8333 10 15.8333C11.3261 15.8333 12.5979 15.5699 13.5355 15.1011C14.4732 14.6322 15 13.9963 15 13.3333V10.4166",
    stroke: "#726C6C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreshersOnly);
export default __webpack_public_path__ + "static/media/freshers-only.ee09e2bccfb1978af7d67f7023bf5bac.svg";
export { ForwardRef as ReactComponent };